<template>
  <div id="dashboard">
    <TitleComponent />
    <div class="card mt-3">
      <div class="card-body text-center">
        <h4 style="font-size: 30px">Selamat datang di Dashboard</h4>
        <p style="font-size: 15px">Aplikasi upload gambar produk</p>
      </div>
    </div>
  </div>
</template>
<script>
import TitleComponent from "@/components/TitleComponent.vue";

export default {
  name: "DashboardView",
  components: { TitleComponent },
};
</script>
